import { useState } from 'react';
import { useAccount } from 'frontastic/hooks';
import { gtmFormStartInteraction, gtmFormSubmit } from 'helpers/utils/gtm-events/gtmInteraction';

const useFormInteraction = (formName: string) => {
  const [hasInteracted, setHasInteracted] = useState(false);
  const { account } = useAccount();

  const handleStartInteraction = () => {
    if (!hasInteracted) {
      setHasInteracted(true);
      gtmFormStartInteraction(formName);
    }
  };

  const handleSubmitInteraction = async ({
    email,
    newsletterOptIn,
    referralSource,
    catalogueFormat,
    country,
    region,
  }: {
    newsletterOptIn?: boolean;
    email?: string;
    referralSource?: string;
    catalogueFormat?: string;
    country?: string;
    region?: string;
  }) => {
    gtmFormSubmit({
      formName,
      hashedEmail: email
        ? (await import('helpers/stringHelpers/CryptoHelper')).CryptoHelper.convertToSHA256Hash(email)
        : account?.emailHash || undefined,
      newsletterOptIn,
      referralSource,
      catalogueFormat,
      country,
      region,
    });
  };

  return { hasInteracted, handleStartInteraction, handleSubmitInteraction };
};

export default useFormInteraction;
